import { Option } from '../../../models';

export const optionHeader: Option = { label: 'Cabeçalho', value: 'header', hidden: true };

export const staticOptions: Option[] = [
  // { label: 'Código de Barra', value: 'barcode' },
  { label: 'Localização (Opcional)', value: 'location', required: false },
  { label: 'Data Estimada para Exclusão', value: 'exclusionDate', required: true },
];
